function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12.61 2.21a.99.99 0 00-1.22 0C9.49 3.66 3.88 8.39 3.91 13.9c0 4.46 3.63 8.1 8.1 8.1s8.1-3.63 8.1-8.09c.01-5.43-5.61-10.24-7.5-11.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.09 14.2a7.67 7.67 0 01-.27 1.79l-7.07 3.44v2.54a9.401 9.401 0 01-1.5 0V2.31c.05-.04.09-.07.13-.1.37-.28.87-.28 1.23 0 .04.03.09.07.14.11v5.44l3.78-1.84c.33.38.64.77.95 1.18a.38.38 0 01-.13.09l-4.6 2.24v3.33l6.29-3.06c.01 0 .01-.01.02-.01.22.45.41.91.56 1.39l-6.87 3.35v3.33l6.62-3.22.72-.34z"
})));